$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navmobile-button").click(function () {
        $(".js-navmobile").toggleClass("active");
        $("body, html").toggleClass("freeze");
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-navmobile").removeClass("active");
            $("body, html").removeClass("freeze");
        }
    });
 


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: false,
                adaptiveHeight: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-pagination-prev"),
                nextArrow: $(this).find(".js-pagination-next"),
                touchMove: true,
                swipe: true,
                swipeToSlide: true,
                touchThreshold: 10,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            speed: 500
                        }
                    }
                ]
            });
            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-hero-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: false,
                adaptiveHeight: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-pagination-prev"),
                nextArrow: $(this).find(".js-pagination-next"),
                touchMove: true,
                swipe: true,
                swipeToSlide: true,
                touchThreshold: 10,
                touchMove: true,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            speed: 500
                        }
                    }
                ]
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard
    // *
    // *
    var $sliderCard = $(".js-slidercard"); 

    if ($sliderCard.length) {
        var initialSettings = {
            infinite: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 7000,
            cssEase: 'linear',
            waitForAnimate: false,
            centerMode: true,
            variableWidth: true,
            pauseOnHover: false,
            touchMove: true,
            swipe: true,
            responsive: [{
                breakpoint: 700,
                settings: {
                    speed: 5000
                }
            }]
        };
        
        $sliderCard.slick(initialSettings); 
        
        $sliderCard.one('swipe', function() {
            if (window.innerWidth < 700) {
                var $this = $(this);
                $this.addClass("swipeable");
                var newSettings = {
                    infinite: true,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    speed: 500,
                    cssEase: 'ease',
                    waitForAnimate: false,
                    centerMode: true,
                    variableWidth: true,
                    touchMove: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    touchMove: true
                };
                $this.slick('unslick').slick(newSettings);
            }
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * carouselCard
    // *
    // *
    var $carouselCard = $(".js-carouselcard");

    if ($carouselCard.length) {
        $carouselCard.each(function () {
            $(this).find(".js-carouselcard-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                slidesToShow: 4,
                waitForAnimate: false,
                adaptiveHeight: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).find(".js-pagination-prev"),
                nextArrow: $(this).find(".js-pagination-next"),
                swipeToSlide: true,
                touchThreshold: 10,
                swipe: true,
                touchMove: true,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1110,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 1,
                            speed: 500
                        }
                    }
                ]
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * cardFlip
    // *
    // *
    $(".js-cardflip-button").click(function() {
        const cardFlip = $(this).parents(".js-cardflip");
        cardFlip.toggleClass("active");

        if ($(window).width() < 700) {
            // --- Dieser Teil wird NUR auf kleinen Bildschirmen ausgeführt ---
            if (cardFlip.hasClass("active")) {
                const backElement = cardFlip.find(".cardFlip__back")[0];
                const contentHeight = backElement.scrollHeight;
                cardFlip.css("height", contentHeight);
            } else {
                cardFlip.css("height", "");
            }
        } else {
            // --- Auf großen Bildschirmen (>700px) ---
            // Sicherstellen, dass keine inline-Höhe gesetzt ist, damit CSS die Kontrolle hat
            cardFlip.css("height", "");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        // setTimeout(() => {
        //     $(this)[0].scrollIntoView({ behavior: 'smooth' });
        // }, 400);
    });

    $(".js-accordion-button.active").trigger("click");

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    
    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState'),
        lastFocusedElement = null;

    // Alle fokussierbaren Elemente im Dialog
    function getFocusableElements() {
        return $dialog.find(
            'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');
    }

    function trapFocus(e) {
        var focusable = getFocusableElements();
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        // ESC zum Schließen
        if (e.key === "Escape") {
            e.preventDefault();
            closeDialog();
            return;
        }

        // Tab-Trap
        if (e.key === "Tab") {
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    function openDialog() {
        lastFocusedElement = document.activeElement;

        $dialog.addClass("is-open");
        $("body").addClass("freeze");
        $dialog.removeAttr("inert");
        $dialog.attr("aria-hidden", "false");

        // Fokus auf erstes Element setzen
        var focusable = getFocusableElements();
        if (focusable.length) {
            focusable[0].focus();
        }

        document.addEventListener("keydown", trapFocus);
    }

    function closeDialog() {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $("body").removeClass("freeze");

        setTimeout(function() {
            $dialog.removeClass("is-open close");
            $dialog.attr("aria-hidden", "true");
            $dialog.attr("inert", "");

            // Fokus zurück zum vorherigen Element
            if (lastFocusedElement) {
                $(lastFocusedElement).focus();
            }

            document.removeEventListener("keydown", trapFocus);
        }, 300); // zur Animationsdauer passend
    }

    $(".js-close-dialog").click(closeDialog);

    // backdrop click
    $dialog.click(function (e) {
        if (e.target === e.currentTarget) closeDialog();
    });

    // Initial öffnen
    if (!dialogState && $dialog.length > 0) {
        setTimeout(openDialog, 1500);
    }

    // Manueller Trigger
    $(".js-open-dialog").click(function() {
        $(".js-navmobile.active .js-navmobile-button").trigger("click");
        openDialog();
    });

});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("scrolled");
    } else {
        $(".js-header").removeClass("scrolled");
    }
});
